/* eslint-disable jira/filename-case */
import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { defineMessage } from '@atlassian/jira-intl';
import Breadcrumb from '../../breadcrumb/component.tsx';
import type { BreadcrumbData } from '../../types.tsx';
import { createProjectUrl } from '../common/create-url/index.tsx';
import type { ProjectBreadcrumbPropsWithIntl } from './types.tsx';

const projectsTitle = defineMessage({
	id: 'platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title',
	defaultMessage: 'Projects',
	description: 'Title of the breadcrumb that navigates to projects directory page',
});

const projectsTitleGalaxia = defineMessage({
	id: 'platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title-galaxia',
	defaultMessage: 'Spaces',
	description: 'Title of the breadcrumb that navigates to projects directory page',
});

const ProjectBreadcrumb = ({
	isSimplifiedProject = false,
	children = null,
	projectKey = undefined,
	projectName = undefined,
	projectId = undefined,
	intl: { formatMessage },
}: ProjectBreadcrumbPropsWithIntl): React.JSX.Element => {
	const ProjectsBreadcrumb: BreadcrumbData = {
		href: '/jira/projects',
		text: formatMessage(
			expVal('project-terminology-refresh', 'isEnabled', false)
				? projectsTitleGalaxia
				: projectsTitle,
		),
		type: 'projectsDirectory',
		analyticsAttributes: {
			nextGenProject: isSimplifiedProject,
			projectConfig:
				isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic',
		},
		analyticsFields: {
			name: 'navigateToProjectsList',
		},
	};

	if (projectKey != null && projectName != null) {
		const breadcrumb: BreadcrumbData = {
			href: createProjectUrl(projectKey),
			text: projectName,
			type: 'projectName',
			analyticsAttributes: {
				nextGenProject: isSimplifiedProject,
				projectConfig:
					isSimplifiedProject !== undefined && isSimplifiedProject === true
						? 'next-gen'
						: 'classic',
			},
			analyticsFields: {
				name: 'navigateToProject',
				containerId: projectId,
				containerType: 'project',
			},
		};
		const ProjectNameBreadcrumb = <Breadcrumb breadcrumb={breadcrumb}>{children}</Breadcrumb>;
		return <Breadcrumb breadcrumb={ProjectsBreadcrumb}>{ProjectNameBreadcrumb}</Breadcrumb>;
	}

	return <Breadcrumb breadcrumb={ProjectsBreadcrumb}>{children}</Breadcrumb>;
};

export default ProjectBreadcrumb;
